import React, { useState, useRef, useCallback, useMemo } from "react";
import { apiBaseURL } from "../../../Utils/ProjectConstants";
import {
  TreeList,
  Button,
  Lookup,
  SearchPanel,
  Scrolling,
  ColumnFixing,
  Popup,
  Toolbar,
  Item,
} from "devextreme-react/tree-list";
import AddRowButton from "devextreme-react/button";
import ActionNotifications from "../../../Components/ActionNotifications";
import { Editing, Column } from "devextreme-react/gantt";
import { Format } from "devextreme-react/chart";
import HistoryPopup from "./historyPopup";
import WorkOrderPopup from "./workOrderPopup";
import BudgetFormPopup from "./budgetFormPopup";
import TaskFormPopup from "./taskFormPopup";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import { exportTreeList } from "./excelExporter";
import useFetchWorkPlans from "../../../Hooks/dataFetcher/useFetchWorkPlans";
import { checkRoles } from "../../../Utils/helper";

const dateOptions = {
  format: { type: "shortDate" },
  useMaskBehavior: true,
  placeholder: "mm/dd/yyyy",
};
export default function ProjectTreeList({ projectId, fetchSuccessful, fetch }) {
  const treeList = useRef();
  const { allProjects, mutate } = useFetchWorkPlans(projectId);
  const [notifyResponse, setNotification] = useState(null),
    [showPopup, setPopup] = useState({
      history: null, //object {info}
      workOrder: null,
      budget: null,
      openForm: null,
    });

  const exportToExcel = useCallback(() => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("Project Work Plan");

    if (treeList.current !== null) {
      exportTreeList({
        data: allProjects,
        component: treeList.current.instance,
        worksheet,
      })
        .then(() => {
          workbook.xlsx
            .writeBuffer()
            .then((buffer) => {
              saveAs(
                new Blob([buffer], { type: "application/octet-stream" }),
                "Project_Work_Plan.xlsx"
              );
            })
            .catch(() => {});
        })
        .catch(() => {});
    }
  }, []);

  const exportButtonOptions = useMemo(
    () => ({
      icon: "xlsxfile",
      onClick: exportToExcel,
    }),
    []
  );

  const handlePopup = useCallback((popupKey, data) => {
    console.log("handlePopup data", data);
    setPopup((prevState) => ({
      ...prevState,
      [popupKey]: { data },
    }));
  }, []);

  const handleClose = (popupKey) => {
    setPopup((prevState) => ({
      ...prevState,
      [popupKey]: null,
    }));
  };

  const addRow = useCallback(() => {
    console.log("Heyya");
  }, []);

  const allowDeleting = async (e) => {
    const response = await fetch.delete(
      `${apiBaseURL}/api/projectwo?id=${e.data.id}`
    );

    console.log(response);
    if (fetchSuccessful(response)) {
    }
  };

  return (
    <>
      <ActionNotifications response={notifyResponse} />
      {showPopup.history && (
        <HistoryPopup
          selectedData={showPopup.history.data}
          onClose={() => handleClose("history")}
        />
      )}
      {showPopup.workOrder && (
        <WorkOrderPopup
          selectedData={showPopup.workOrder.data}
          onClose={() => handleClose("workOrder")}
        />
      )}
      {showPopup.budget && (
        <BudgetFormPopup
          setNotification={setNotification}
          data={showPopup.budget.data}
          onClose={() => handleClose("budget")}
        />
      )}
      {showPopup.openForm && (
        <TaskFormPopup
          projectId={projectId}
          setNotification={setNotification}
          data={showPopup.openForm.data}
          onClose={() => handleClose("openForm")}
          mutate={mutate}
        />
      )}
      <TreeList
        id="treelist" //??
        ref={treeList}
        className="contentBox"
        rootValue={projectId}
        dataSource={allProjects} //state.allProjects?
        showRowLines={true}
        showColumnLines={true}
        showBorders={true}
        height={600}
        columnAutoWidth={true} //causing weird glitches
        allowColumnResizing={true}
        columnResizingMode="widget"
        columnHidingEnabled={true}
        autoExpandAll={true}
        wordWrapEnabled={true}
        keyExpr="billingCode"
        parentIdExpr="headId"
        onInitNewRow={
          (e) =>
            console.log(
              "new e",
              e
            ) /*(e) => handlePopup('openForm', { rowData: e.row, newForm: true })*/
        }
        onEditorPreparing={onEditorPreparing}
        onRowPrepared={onRowPrepared}
        onRowRemoved={allowDeleting}
        searchEnabled={true}
      >
        <Scrolling mode="virtual" />
        <SearchPanel visible={true} />

        <Editing
          //allowUpdating={true}
          allowAdding={true}
          allowDeleting={checkRoles(5)}
          mode="popup"
        />
        <ColumnFixing enabled={true} />

        <Column dataField="billingCode" allowEditing={false} />
        <Column dataField="taskName" />
        <Column
          dataField="durationInDays"
          caption="Duration"
          allowEditing={false}
        />
        <Column
          dataField="startDate"
          dataType="date"
          editorOptions={dateOptions}
        />
        <Column
          dataField="endDate"
          dataType="date"
          editorOptions={dateOptions}
        />
        <Column
          dataField="completedPercentage"
          caption="% Complete"
          allowEditing={false}
        />
        <Column
          dataField="supervisorIds"
          caption="Assigned to"
          minWidth={200}
          calculateDisplayValue={calculateDisplayValue}
        >
          <Lookup />{" "}
          {/*keep this to trigger the lookup param when exporting to excel*/}
        </Column>
        <Column
          dataField="allocatedEngHours"
          caption="Allocated Proj/Eng Hours"
          dataType="number"
        >
          <Format type="fixedPoint" precision={2} />
        </Column>
        <Column
          dataField="actualEngHoursRES"
          caption="Actual Proj/Eng Hours"
          dataType="number"
          allowEditing={false}
        >
          <Format type="fixedPoint" precision={2} />
        </Column>
        <Column
          dataField="actualEngHoursOPR"
          caption="Actual Cell Personnel Hours"
          dataType="number"
          allowEditing={false}
        >
          <Format type="fixedPoint" precision={2} />
        </Column>
        <Column
          dataField="allocatedLabHours"
          caption="Allocated Cell Hours"
          dataType="number"
          allowEditing={false}
        >
          <Format type="fixedPoint" precision={2} />
        </Column>
        <Column
          dataField="actualLabHours"
          caption="Actual Cell Hours"
          dataType="number"
          allowEditing={false}
        >
          <Format type="fixedPoint" precision={2} />
        </Column>
        <Column dataField="remarks" visible={false} />
        {/* side buttons */}
        <Column type="buttons">
          <Button
            text="Work Orders"
            icon="message"
            visible={true}
            onClick={(selectedRow) => handlePopup("workOrder", selectedRow)}
          />
          <Button
            text="Edit History"
            icon="info"
            visible={true}
            onClick={(selectedRow) => handlePopup("history", selectedRow)}
          />
          <Button
            text="Add Budget"
            icon="money"
            visible={checkRoles(2)}
            onClick={(e) => handlePopup("budget", e)}
          />
          <Button
            text="Add Task"
            icon="add"
            visible={checkRoles(2)}
            onClick={(e) =>
              handlePopup("openForm", { rowData: e.row, newForm: true })
            }
          />
          <Button
            text="Edit Task"
            icon="edit"
            visible={checkRoles(2)}
            onClick={(e) =>
              handlePopup("openForm", { rowData: e.row, newForm: false })
            }
          />
          <Button name="delete" visible={checkRoles(5)} />
        </Column>
        <Toolbar>
          <Item
            name="exportToXlsx"
            widget="dxButton"
            locateInMenu="auto"
            options={exportButtonOptions}
          />
          <Item>
            <AddRowButton
              icon="plus"
              onClick={(e) =>
                handlePopup("openForm", { rowData: projectId, newForm: true })
              }
            />
          </Item>
          <Item name="searchPanel" />
        </Toolbar>
      </TreeList>
    </>
  );
}

const onEditorPreparing = (e) => {
  //prevent top task from needing a head id?
  if (e.dataField === "Head_ID" && e.row.data.ID === 1) {
    e.cancel = true;
  }
  if (
    (e.parentType === "dataRow" || e.parentType === "filterRow") &&
    e.dataField === "supervisorIds"
  ) {
    e.editorName = "dxTagBox";
    //e.editorOptions.dataSource = allSupervisors;
    e.editorOptions.showSelectionControls = true;
    e.editorOptions.displayExpr = "label";
    e.editorOptions.valueExpr = "value";
    e.editorOptions.value = e.value || [];
    //e.editorOptions.customItemCreateEvent;
    e.editorOptions.onValueChanged = (x) => {
      //replace?
      console.log(x);
      e.setValue(x.value);
    };
  }
};
const onRowPrepared = (e) => {
  //console.log(e)
  if (e.data) {
    if (e.data && e.node.expanded) {
      e.rowElement.style.backgroundColor = "transparent";
    }
    if (e.level === 1) {
      e.rowElement.style.fontWeight = "bold";
    }
  }
  if (e.rowType === "header") {
    e.rowElement.style.backgroundColor = "#FFCD00";
    e.rowElement.style.fontWeight = "bold";
  }
};

const calculateDisplayValue = (rowData) => {
  const supervisor = rowData.supervisors && rowData.supervisors[0];
  return supervisor ? `${supervisor.firstName} ${supervisor.lastName}` : "";
};
